import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import { getVariant, getDeliveryPrice } from '@/helpers/QueryHelpers';

export default class GetCouponByCouponCode {
    apiService;

    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    handle(coupon) {
        let apiUrl = url(ApiEndpoints['coupons.show'], [coupon], {
            delivery_amount: getDeliveryPrice(),
            mode: getVariant(),
            free_first_delivery: false,
        });

        return this.apiService.get(apiUrl);
    }
}
